/**
 * SegregacaoConsolidadoReport - Segregated items with aging, lacre, O.C. (paginated)
 */
import React from 'react';
import { RelatorioGeraisTable, type Column } from './RelatorioGeraisTable';

const columns: Column[] = [
  { key: 'cliente_nome', label: 'Cliente', width: '160px' },
  { key: 'hospital_codigo', label: 'Código', align: 'center', width: '90px' },
  { key: 'hospital_nome', label: 'Nome', width: '180px' },
  { key: 'data_solicitacao_coleta', label: 'Data Solic. Coleta', format: 'date', width: '130px' },
  { key: 'legado', label: 'Legado', align: 'center', width: '80px' },
  { key: 'bu_primaria', label: 'BU Primária', width: '100px' },
  { key: 'bu_secundaria', label: 'BU Secundária', width: '100px' },
  { key: 'codigo_produto', label: 'Produto', width: '130px' },
  { key: 'descricao', label: 'Descrição', width: '220px' },
  { key: 'lote', label: 'Lote', width: '110px' },
  { key: 'data_validade', label: 'Validade', format: 'date', width: '100px' },
  { key: 'faixa_aging', label: 'Faixa Aging', align: 'center', width: '140px' },
  { key: 'quantidade_segregada', label: 'Segregado', align: 'right', format: 'decimal', width: '90px' },
  { key: 'motivo_segregacao', label: 'Motivo Segregação', width: '150px' },
  { key: 'lacre', label: 'Lacre', width: '100px' },
  { key: 'ordem_coleta', label: 'O.C.', align: 'center', width: '80px' },
];

interface Props {
  data: any[];
  loading?: boolean;
  totalRecords?: number;
  currentPage?: number;
  totalPages?: number;
  onPageChange?: (page: number) => void;
}

export const SegregacaoConsolidadoReport: React.FC<Props> = ({
  data,
  loading,
  totalRecords,
  currentPage,
  totalPages,
  onPageChange,
}) => {
  return (
    <RelatorioGeraisTable
      columns={columns}
      data={data}
      loading={loading}
      totalRecords={totalRecords}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={onPageChange}
      emptyMessage="Nenhum item segregado encontrado no período selecionado."
    />
  );
};
